import React from "react";

export default function DroneDashHistory({ game, onClose }) {
  const rows = game.history || [];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4">
      <div className="w-full max-w-sm rounded-3xl bg-slate-950 border border-slate-800 p-5 max-h-[80vh] flex flex-col">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-cyan-200 font-black text-lg">📈 Flight History</h2>
          <button onClick={onClose} className="text-xs text-slate-300 border border-slate-700 rounded-lg w-fit px-3 py-1">
            Close
          </button>
        </div>

        {game.bestRecord && (
          <div className="rounded-xl bg-gradient-to-r from-sky-600/30 to-emerald-600/30 border border-sky-700/40 px-3 py-2 mb-3 text-center">
            <div className="text-xs text-slate-400">Personal best</div>
            <div className="text-xl font-black text-white">{game.bestRecord.score}</div>
          </div>
        )}

        {game.loadingHistory && <div className="text-slate-400 text-sm text-center py-6">Loading…</div>}

        {!game.loadingHistory && (
          <div className="space-y-2 overflow-y-auto">
            {rows.length === 0 && (
              <div className="text-slate-500 text-sm text-center py-8">No flights logged yet.</div>
            )}
            {rows.map((item) => (
              <div key={item._id} className="rounded-xl bg-slate-900/80 border border-slate-800 px-3 py-2">
                <div className="flex items-center justify-between">
                  <span className="text-xs text-slate-400">
                    {item.playDate} · {item.mode === "conflict" ? "⚔️ Conflict" : "🕊 Peace"} · {item.difficulty}
                  </span>
                  <span className="text-sm font-bold text-cyan-300">{item.score} pts</span>
                </div>
                <div className="text-[11px] text-slate-500 mt-0.5">
                  {item.totalTimeSec}s flight · {item.packagesCollected || 0} parcels
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
